import { render, staticRenderFns } from "./refreshable-timeago.vue?vue&type=template&id=17f99d8e"
import script from "./refreshable-timeago.vue?vue&type=script&lang=js"
export * from "./refreshable-timeago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports